export function isMobile() {
  let ua = window.navigator.userAgent;
  return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/.test(
    ua,
  );
}

export function getCurrentMenu(menu, currentRoute) {
  for (const m of menu) {
    if (m.name === currentRoute.meta[0]?.nodeid) {
      return m;
    }

    if (m.children) {
      const currentMenu = getCurrentMenu(m.children, currentRoute);

      if (currentMenu) {
        return currentMenu;
      }
    }
  }

  return undefined;
}

export function setHomeToRoot(menu) {
  menu.forEach(e => {
    if (e.type == "Home") {
      e.path = "/";
    }
  });
}
export const formatDate = dateString => {
  const date = new Date(dateString);
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const day = date.getDate();
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  const formattedDate = `${month} ${day},${year}`;
  return formattedDate;
};

export const deepClone = value => {
  const cache = new Map();

  function _deepClone(value) {
    if (value === null || typeof value !== "object") {
      return value;
    }
    if (cache.has(value)) {
      return cache.get(value);
    }
    const result = Array.isArray(value) ? [] : {};
    cache.set(value, result);
    for (const key in value) {
      result[key] = _deepClone(value[key]);
    }
    return result;
  }

  return _deepClone(value);
};

export const LoadingImage = () => {
  const ob = new IntersectionObserver(
    entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;

          let nextSibling = img.nextSibling;
          if (nextSibling) {
            img.onload = function () {
              img.nextSibling.nextSibling.style.display = "none";
            };
          }
          ob.unobserve(img);
        }
      }
    },
    {
      threshold: 0.5,
    },
  );
  setTimeout(() => {
    const imgs = document.querySelectorAll("img[data-src]");
    imgs.forEach(img => {
      ob.observe(img);
    });
  }, 500);
};

export const flatTreeData = tree => {
  const res = [];
  function getData(list) {
    list.forEach(item => {
      res.push(item);
      if (item.children) {
        getData(item.children);
      }
    });
  }
  getData(tree);
  return res;
};

export const findParentElements = (
  id,
  tree,
  path,
  ID,
  products,
  type = "normal",
) => {
  const element = tree.find(item => {
    if (type === "productDetail") {
      const currentMenu = products.find(v => v.ID === ID);

      let currentPath = "";
      if (path.endsWith("/")) {
        currentPath = path.slice(0, this.$route.path.length - 1);
      } else {
        currentPath = path;
      }

      return (
        item.parentid === id &&
        currentPath.includes(item.path) &&
        item.type === "productsclass" &&
        currentMenu.glid === item.ID
      );
    }
    return item.name === id;
  });

  const parents = [];

  if (!element) {
    return parents; // 没有找到元素
  }
  parents.push(element);
  // 查找父元素
  function findParent(parentId) {
    const parentElement = tree.find(
      item =>
        item.name === parentId ||
        (item.parentid === "menu-tree" &&
          item.name === parents[parents.length - 1].parentid),
    );
    if (parentElement) {
      parents.push(parentElement);
      if (parentElement.parentid === "menu-tree") {
        return parents;
      }
      findParent(parentElement.parentid); // 查找上层父元素
    }
  }
  findParent(element.parentid); // 开始从找到的元素的 parentid 开始查找
  return parents.reverse(); // 反转数组以从顶部到底部返回
};

/**
 * @param {Array} nodes - 树形结构的数组，每个元素都可能包含一个 children 属性，其中存储其子节点。
 * @returns {Array} 返回一个包含所有节点的扁平数组，每个节点都不含 children 属性。
 */
export const flattenTree = nodes => {
  const result = []; // 初始化结果数组

  /**
   * 递归遍历树形数据结构的函数。
   * @param {Array} currentNodes - 当前遍历到的节点数组。
   */
  function traverse(currentNodes) {
    currentNodes.forEach(node => {
      const { children, ...nodeWithoutChildren } = node;
      result.push(nodeWithoutChildren);
      if (children && children.length > 0) {
        traverse(children);
      }
    });
  }
  traverse(nodes);
  return result;
};

// ===========================
// 工具函数：查找路径
// ===========================
export const findPathToNode = (menus, targetId, path = []) => {
  for (const node of menus) {
    const newPath = [...path, node]; // 避免共享引用污染
    if (node.ID === targetId) return newPath;
    if (Array.isArray(node.children) && node.children.length > 0) {
      const result = findPathToNode(node.children, targetId, newPath);
      if (result) return result;
    }
  }
  return null;
};

// ===========================
// 工具函数：条件筛选节点
// ===========================
export const getNodesByCondition = (menus, condition) => {
  const result = [];
  const queue = [...menus];
  while (queue.length > 0) {
    const menu = queue.shift();
    if (menu && condition(menu)) result.push(menu);
    if (Array.isArray(menu?.children)) queue.push(...menu.children);
  }
  return result;
};

export const getSiteOrigin = () => {
  const rawOrigin = process.env.ORIGIN || "https://www.example.com";
  if (/^https?:\/\//.test(rawOrigin)) return rawOrigin.replace(/\/$/, "");
  return rawOrigin.startsWith("www")
    ? `https://${rawOrigin}`
    : `https://www.${rawOrigin}`;
};

const toAbsoluteUrl = (path, siteUrl = getSiteOrigin()) => {
  if (!path) return undefined;
  return new URL(path, siteUrl).toString();
};

const cleanJsonLd = value => {
  if (Array.isArray(value)) {
    return value.map(cleanJsonLd).filter(item => item !== undefined);
  }

  if (value && typeof value === "object") {
    return Object.entries(value).reduce((result, [key, item]) => {
      if (item === undefined || item === null || item === "") return result;
      const nextItem = cleanJsonLd(item);
      if (nextItem === undefined) return result;
      if (Array.isArray(nextItem) && nextItem.length === 0) return result;
      if (
        nextItem &&
        typeof nextItem === "object" &&
        !Array.isArray(nextItem) &&
        Object.keys(nextItem).length === 0
      ) {
        return result;
      }
      result[key] = nextItem;
      return result;
    }, {});
  }

  return value;
};

const getRouteMeta = meta => (Array.isArray(meta) ? meta[0] : meta) || {};

export const buildOrganizationJsonLd = ({
  baseInfo = {},
  footerData = {},
  siteUrl = getSiteOrigin(),
}) => {
  const logoUrl = toAbsoluteUrl(footerData?.piclogo?.logourl, siteUrl);
  return cleanJsonLd({
    "@context": "https://schema.org",
    "@type": "Organization",
    name: baseInfo.companyName || baseInfo.company_name,
    legalName: baseInfo.companyName || baseInfo.company_name,
    brand: {
      "@type": "Brand",
      name:
        baseInfo.brandName ||
        baseInfo.brand_name ||
        baseInfo.companyName ||
        baseInfo.company_name,
    },
    url: siteUrl,
    logo: logoUrl,
    image: logoUrl,
    address: {
      "@type": "PostalAddress",
      streetAddress: baseInfo.address,
    },
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      telephone: baseInfo.phoneNumber || baseInfo.phone,
      email: Array.isArray(baseInfo.email) ? baseInfo.email[0] : baseInfo.email,
    },
  });
};

export const buildPageJsonLd = ({
  type = "WebPage",
  route,
  meta,
  siteUrl = getSiteOrigin(),
  baseInfo,
  footerData,
  includePublisher = false,
}) => {
  const routeMeta = getRouteMeta(meta);
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": type,
    name: routeMeta.title,
    description: routeMeta.description,
    keywords: routeMeta.keywords,
    url: toAbsoluteUrl(route?.path || "/", siteUrl),
  };

  if (includePublisher) {
    jsonLd.publisher = buildOrganizationJsonLd({
      baseInfo,
      footerData,
      siteUrl,
    });
  }

  return cleanJsonLd(jsonLd);
};

export const buildWebsiteJsonLd = data => {
  const siteUrl = data?.siteUrl || getSiteOrigin();
  return cleanJsonLd({
    ...buildPageJsonLd({
      ...data,
      type: "WebSite",
      siteUrl,
    }),
    potentialAction: {
      "@type": "SearchAction",
      target: `${siteUrl}/search?keywords={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  });
};

export const buildBreadcrumbJsonLd = itemListElement =>
  cleanJsonLd({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement,
  });

export const buildArticleJsonLd = ({
  route,
  meta,
  siteUrl = getSiteOrigin(),
  baseInfo,
  footerData,
  article = {},
  imageKey,
}) => {
  const routeMeta = getRouteMeta(meta);
  const imageUrl = toAbsoluteUrl(article?.[imageKey], siteUrl);
  return cleanJsonLd({
    ...buildPageJsonLd({
      type: "Article",
      route,
      meta,
      siteUrl,
      baseInfo,
      footerData,
      includePublisher: true,
    }),
    headline: routeMeta.title || article.name || article.name_ch,
    name: routeMeta.title || article.name || article.name_ch,
    description: routeMeta.description || article.description,
    keywords: routeMeta.keywords || article.keywords,
    datePublished: article.public_time || article.createTime,
    dateModified: article.updateTime || article.public_time || article.createTime,
    image: imageUrl
      ? {
          "@type": "ImageObject",
          url: imageUrl,
        }
      : undefined,
    author: {
      "@type": "Organization",
      name:
        baseInfo?.companyName ||
        baseInfo?.company_name ||
        baseInfo?.brandName ||
        baseInfo?.brand_name,
    },
  });
};

export const buildProductJsonLd = ({
  route,
  meta,
  siteUrl = getSiteOrigin(),
  baseInfo,
  footerData,
  product = {},
}) => {
  const routeMeta = getRouteMeta(meta);
  const imageUrl = toAbsoluteUrl(product.showPic, siteUrl);
  const price = ["price", "productPrice", "salePrice"]
    .map(key => Number(product[key]))
    .find(value => Number.isFinite(value) && value > 0);
  const jsonLd = {
    ...buildPageJsonLd({
      type: "Product",
      route,
      meta,
      siteUrl,
      baseInfo,
      footerData,
      includePublisher: true,
    }),
    name: product.name || product.name_ch || routeMeta.title,
    description: product.productDes || routeMeta.description || product.description,
    keywords: routeMeta.keywords || product.keywords,
    sku: product.sku || product.ID,
    image: imageUrl,
  };

  if (price) {
    jsonLd.offers = {
      "@type": "Offer",
      priceCurrency: product.priceCurrency || "USD",
      price,
      availability: "https://schema.org/InStock",
      url: toAbsoluteUrl(route?.path || product.path, siteUrl),
    };
  }

  return cleanJsonLd(jsonLd);
};

export const pickProductCards = (list = [], withDescription = false) =>
  (list || []).map(item => {
    const result = {
      ID: item.ID,
      glid: item.glid,
      name: item.name,
      name_ch: item.name_ch,
      path: item.path,
      showPic: item.showPic,
    };
    if (withDescription) result.productDes = item.productDes;
    return result;
  });

export const pickArticleCards = (list = [], imageKey = "newsPic") =>
  (list || []).map(item => ({
    ID: item.ID,
    glid: item.glid,
    name: item.name,
    name_ch: item.name_ch,
    path: item.path,
    [imageKey]: item[imageKey],
    public_time: item.public_time,
    createTime: item.createTime,
    updateTime: item.updateTime,
  }));

export const pickNavArticle = item =>
  item
    ? {
        ID: item.ID,
        glid: item.glid,
        name: item.name,
        name_ch: item.name_ch,
        path: item.path,
      }
    : {};

export const pickBreadcrumbItems = (list = []) =>
  (list || []).map(item => ({
    ID: item.ID,
    name: item.name,
    name_ch: item.name_ch,
    parentid: item.parentid,
    path: item.path,
    type: item.type,
  }));

export const pickMenuTree = (list = []) =>
  (list || []).map(item => ({
    ID: item.ID,
    name: item.name,
    name_ch: item.name_ch,
    parentid: item.parentid,
    path: item.path,
    type: item.type,
    children: item.children ? pickMenuTree(item.children) : [],
  }));

export const pickAboutSummary = aboutUs =>
  aboutUs
    ? {
        ID: aboutUs.ID,
        name: aboutUs.name,
        name_ch: aboutUs.name_ch,
        content: aboutUs.content,
      }
    : {};

// ===========================
// 生成基础 JSON-LD
// ===========================
export const getBaseJsonLd = data => {
  const origin = data?.origin || "https://www.example.com";
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: data?.companyName || "company",
    url: origin,
    publisher: {
      "@type": "Organization",
      name: data?.companyName || "company",
      brand: {
        "@type": "Brand",
        name: data?.brandName || "brandName",
      },
      address: {
        "@type": "PostalAddress",
        streetAddress: data?.address || "address",
      },
      contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer service",
        telephone: data?.phoneNumber,
        email: data?.email || "",
        availableLanguage: data.availableLanguage,
        logo: new URL(data?.logo || "", origin).toString(),
      },
    },
    mainEntity: {
      "@type": "ItemList",
      itemListElement: data?.itemListElement || [],
    },
    potentialAction: {
      "@type": "SearchAction",
      target: `${origin}/search?keywords={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };
};

// ===========================
// JSON-LD 总生成器
// ===========================
export const generateJsonLd = data => {
  const rawOrigin = process.env.ORIGIN || "https://www.example.com";
  const origin = rawOrigin?.startsWith("www")
    ? "https://" + rawOrigin
    : `https://www.${rawOrigin}`;

  const category = [];
  const menu = data.menu;

  const list = getNodesByCondition(menu, menu => {
    if (menu.type === "products") category.push(...menu.children);
    return true;
  });

  const baseJsonLd = getBaseJsonLd({
    ...data.footerData.visitthird,
    origin,
    category,
    logo: data.footerData.piclogo?.logourl,
    availableLanguage: data.availableLanguage,
    itemListElement: data.itemListElement,
  });

  return {
    baseJsonLd,
    list,
    menu,
    data: [...data.products, ...data.knowledge, ...data.news],
  };
};

export const getJsonLdBread = (id, tree, type = "normal") => {
  const element = tree.find(item => {
    if (type === "productDetail") {
      return item.parentid === id;
    }
    return item.name === id;
  });
  const parents = [];

  if (!element) {
    return parents; // 没有找到元素
  }
  parents.push(element);
  // 查找父元素
  function findParent(parentId) {
    const parentElement = tree.find(item => item.name === parentId);
    if (parentElement) {
      parents.push(parentElement);
      if (parentElement.parentid === "menu-tree") {
        return parents;
      }
      findParent(parentElement.parentid); // 查找上层父元素
    }
  }
  findParent(element.parentid); // 开始从找到的元素的 parentid 开始查找
  return parents.reverse(); // 反转数组以从顶部到底部返回
};

export const getBreadList = (menu, activeItem, type = 1) => {
  let typeList = [];
  if (type === 1) {
    typeList = [
      "productsclass",
      "newsclass",
      "knowledgeclass",
      "about-us",
      "contact",
      "products",
      "news",
      "knowledge",
    ];
  } else {
    typeList = [
      "products",
      "productsclass",
      "productsdetail",
      "news",
      "newsclass",
      "newsdetail",
      "knowledge",
      "knowledgeclass",
      "knowledgedetail",
    ];
  }
  const origin = getSiteOrigin();

  const BreadcrumbList = [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: origin,
    },
  ];

  if (typeList.includes(activeItem.type)) {
    let currentMenu = [];
    if (activeItem.type.includes("class")) {
      currentMenu = menu.filter(m => m.type === activeItem.type.slice(0, -5));
    } else if (activeItem.type.includes("detail")) {
      currentMenu = menu.filter(m => m.type === activeItem.type.slice(0, -6));
    } else {
      currentMenu = menu.filter(m => m.type === activeItem.type);
    }

    const flatArray = flattenTree(currentMenu);
    const breadList = getJsonLdBread(activeItem.ID, flatArray);

    for (const i in breadList) {
      BreadcrumbList.push({
        "@type": "ListItem",
        position: BreadcrumbList.length + 1,
        name: breadList[i].name_ch,
        item: toAbsoluteUrl(breadList[i].path, origin),
      });
    }
  }

  return BreadcrumbList;
};

export const detailJsonLd = (BaseUrl, type, baseJson, list, tdkObj, detail) => {
  if (type === "productsdetail") {
    const detailObj = list.find(v => v.ID === detail.ID);
    Object.assign(baseJson, {
      "@type": "Product",
      name: detailObj?.name,
      description: tdkObj?.description,
      keywords: tdkObj?.keywords,
      image: {
        "@type": "ImageObject",
        url: BaseUrl + detailObj?.showPic,
      },
      sku: "N/A",
      offers: {
        "@type": "AggregateOffer",
        offerCount: 1,
        priceCurrency: "USD",
        lowPrice: 0.0,
        highPrice: 0.0,
        price: 0.0,
      },
    });
  } else if (["newsdetail", "knowledgedetail"].includes(type)) {
    let detailObj = {};
    if (type === "newsdetail") {
      detailObj = list.find(v => v.ID === detail.ID);
    } else {
      detailObj = list.find(v => v.ID === detail.ID);
    }

    Object.assign(baseJson, {
      "@type": "Article",
      headline: tdkObj?.title,
      author: {
        "@type": "Person",
        name: "Anonymous",
      },
      name: tdkObj?.title,
      description: tdkObj?.description,
      keywords: tdkObj?.keywords,
      datePublished: detailObj?.public_time || detailObj?.createTime,
      dateModified: detailObj?.updateTime,
      image: {
        "@type": "ImageObject",
        url: `${BaseUrl}${detailObj?.newsPic || detailObj?.knowledgePic}`,
      },
    });
  }
  return baseJson;
};

export const addForm = data => {
  return new Promise(async (resolve, reject) => {
    const url = new URL("https://ipadmin.aixdb.cn/ipadmin/api/ask/add");
    for (let key in data) {
      url.searchParams.append(key, data[key]);
    }
    let res = await fetch(url);
    resolve(res);
  });
};
